module.exports = __webpack_public_path__ + "img/monday.011d63f9.svg";